import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//import { TestimonyRoutingModule } from './testimony-routing.module';
import { FormsModule } from '@angular/forms';
import { TestimonyComponent } from './testimony.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { TestimonyRoutingModule } from './testimony-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    TestimonyComponent
  ],
  imports: [
    CommonModule,
    TestimonyRoutingModule,
     SharedModule,   
    ReactiveFormsModule,
     HttpClientModule  
  ]
})
export class TestimonyModule { }
